import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IndustrySecondary = (props) => {
    const { title, description } = props;
    return (_jsx("section", { className: "industry-secondary", children: _jsxs("div", { children: [_jsx("p", { className: "industry-secondary__title", children: title }), _jsx("div", { className: "industry-secondary__description", dangerouslySetInnerHTML: { __html: description } })] }) }));
};
export default IndustrySecondary;
